import Pen from "./SVG/pen.svg?react";

const PenIcon = () => {
  return <Pen />;
};

export default PenIcon;
